module.exports = __webpack_public_path__ + "static/media/sinhagad.c4af0667.jpg";